import Dialog from './Dialog';
import DialogsService from './DialogsService';
import DialogsUtils from './DialogsUtils';

class DialogsRegistry {
	// === ДИАЛОГИ ===

	// SYSTEM DIALOGS (СИСТЕМНЫЕ)
	static readonly VApproveDialog = new Dialog('VApproveDialog', () => import('@/core/services/Dialogs/components/VApproveDialog/VApproveDialog.vue'));
	static readonly FeedDialog     = new Dialog('FeedDialog',     () => import('@/core/services/Feeds/components/FeedDialog/FeedDialog.vue'));

	// ORDERS
	static readonly OrderCard                      = new Dialog('OrderCard',                       () => import('@/domains/Orders/components/OrderCard/OrderCard.vue'), 'order');
	static readonly OrderRequisites                = new Dialog('OrderRequisites',                 () => import('@/domains/Orders/components/OrderCard/OrderRequisites.vue'));
	static readonly OrderPositionCodeInfoPopup     = new Dialog('OrderPositionCodeInfoPopup',      () => import('@/domains/Orders/components/OrderPositionCodeInfoPopup/OrderPositionCodeInfoPopup.vue'));
	static readonly OrderPositionPaymentsPopup     = new Dialog('OrderPositionPaymentsPopup',      () => import('@/domains/Orders/components/OrderPositionPaymentsPopup/OrderPositionPaymentsPopup.vue'));
	static readonly OrderPositionPaymentTermsPopup = new Dialog('OrderPositionPaymentTermsPopup',  () => import('@/domains/Orders/components/OrderPositionPaymentTermsPopup/OrderPositionPaymentTermsPopup.vue'));
	static readonly OrderPositionShipmentsPopup    = new Dialog('OrderPositionShipmentsPopup',     () => import('@/domains/Orders/components/OrderPositionShipmentsPopup/OrderPositionShipmentsPopup.vue'));
	static readonly OrderPositionInfoPopup         = new Dialog('OrderPositionInfoPopup',          () => import('@/domains/Orders/components/OrderPositionInfoPopup/OrderPositionInfoPopup.vue'));
	static readonly OrderPositionCloseCard         = new Dialog('OrderPositionCloseCard',          () => import('@/domains/Orders/components/OrderPositionCloseCard/OrderPositionCloseCard.vue'));

  static readonly OrderCurrencyRatesPopup             = new Dialog('OrderCurrencyRatesPopup',             () => import('@/domains/Orders/components/OrderCurrencyRatesPopup/OrderCurrencyRatesPopup.vue'))
  static readonly OrderSumListPopup                   = new Dialog('OrderSumListPopup',                   () => import('@/domains/Orders/components/OrderSumListPopup/OrderSumListPopup.vue'))
	static readonly OrderPositionsRegistryDialog        = new Dialog('OrderPositionsRegistryDialog',        () => import('@/domains/Orders/components/OrderPositionsRegistryDialog/OrderPositionsRegistryDialog.vue'));
  static readonly OrderPositionSetDeliveryDatesDialog = new Dialog('OrderPositionSetDeliveryDatesDialog', () => import('@/domains/Orders/components/OrderPositionSetDeliveryDatesDialog/OrderPositionSetDeliveryDatesDialog.vue'))
  static readonly OrderPositionsClipboardImportDialog = new Dialog('OrderPositionsClipboardImportDialog', () => import('@/domains/Orders/components/OrderPositionClipboardImportDialog/OrderPositionClipboardImportDialog.vue'))
	static readonly OrderPositionRequisites             = new Dialog('OrderPositionRequisites',             () => import('@/domains/Orders/components/OrderPositionCard/OrderPositionRequisites.vue'));
  static readonly OrderPositionCard                   = new Dialog('OrderPositionCard',                   () => import('@/domains/Orders/components/OrderPositionCard/OrderPositionCard.vue'), 'orderPosition')
	static readonly NotifySellerDialog                  = new Dialog('NotifySellerDialog',                  () => import('@/domains/Orders/components/NotifySellerDialog/NotifySellerDialog.vue'));
  static readonly OrderCreateDialogMinimized          = new Dialog('OrderCreateDialogMinimized',          () => import('@/domains/Orders/components/OrderCreateDialogMinimized/OrderCreateDialogMinimized.vue'));

	// ASSEMBLIES (СБОРКИ)
	static readonly AssemblyCard                     = new Dialog('AssemblyCard',                    () => import('@/domains/Assemblies/components/AssemblyCard/AssemblyCard.vue'), 'assembly');
	static readonly AssemblyRequisites               = new Dialog('AssemblyRequisites',              () => import('@/domains/Assemblies/components/AssemblyCard/AssemblyRequisites.vue'));
	static readonly AssemblyPositionImportDialog     = new Dialog('AssemblyPositionImportDialog',    () => import('@/domains/Assemblies/components/AssemblyPositionImportDialog/AssemblyPositionImportDialog.vue'));
  static readonly AssembliesRegistryExpandedDialog = new Dialog('AssembliesRegistryExpandedDialog',() => import('@/domains/Assemblies/components/AssembliesRegistryExpandedDialog.vue'));
  static readonly AssemblyInfoPopup                = new Dialog('AssemblyInfoPopup',               () => import('@/domains/Assemblies/components/AssemblyInfoPopup/AssemblyInfoPopup.vue'));

	// SHIPMENTS (ОТГРУЗКИ)
	static readonly ShipmentCard             = new Dialog('ShipmentCard',             () => import('@/domains/Shipments/components/ShipmentCard/ShipmentCard.vue'), 'shipment');
	static readonly ShipmentRequisites       = new Dialog('ShipmentRequisites',       () => import('@/domains/Shipments/components/ShipmentCard/ShipmentRequisites.vue'));
	static readonly AddServicePositionDialog = new Dialog('AddServicePositionDialog', () => import('@/domains/Shipments/components/ShipmentCard/AddServicePositionDialog.vue'));
	static readonly CreateServiceDialog      = new Dialog('CreateServiceDialog',      () => import('@/domains/Shipments/components/ShipmentCard/CreateServiceDialog.vue'));

	//SHIPMENTS TO BUYER (РЕАЛИЗАЦИИ)
  static readonly ShipmentToBuyerCard   = new Dialog('ShipmentToBuyerCard', () => import('@/domains/ShipmentsToBuyer/components/ShipmentToBuyerCard/ShipmentToBuyerCard.vue'));

  // RECEIPTS (ПРИЕМКИ)
	static readonly ReceiptCard 		          = new Dialog('ReceiptCard',               () => import('@/domains/Receipts/components/ReceiptCard/ReceiptCard.vue'));
	static readonly ReceiptRequisites 	      = new Dialog('ReceiptRequisites',         () => import('@/domains/Receipts/components/ReceiptCard/ReceiptRequisites.vue'));
	static readonly ReceiptPositionDialog     = new Dialog('ReceiptPositionDialog',     () => import('@/domains/Receipts/components/ReceiptCard/ReceiptPositionDialog.vue'));
	static readonly ReceiptNotificationDialog = new Dialog('ReceiptNotificationDialog', () => import('@/domains/Receipts/components/ReceiptNotificationDialog/ReceiptNotificationDialog.vue'));

	// PAYMENT REQUESTS (ПЛАТЕЖИ)
	static readonly PaymentRequestCard                = new Dialog('PaymentRequestCard',                () => import('@/domains/PaymentRequests/components/PaymentRequestCard/PaymentRequestCard.vue'), 'paymentRequest');
	static readonly PaymentRequestRequisites          = new Dialog('PaymentRequestRequisites',          () => import('@/domains/PaymentRequests/components/PaymentRequestCard/PaymentRequestRequisites.vue'));
	static readonly PaymentRequestPositionsDialog     = new Dialog('PaymentRequestPositionsDialog',     () => import('@/domains/PaymentRequests/components/PaymentRequestCard/PaymentRequestPositionsDialog.vue'));
  static readonly PaymentRequestChangePriorityPopup = new Dialog('PaymentRequestChangePriorityPopup', () => import('@/domains/PaymentRequests/components/PaymentRequestChangePriorityPopup.vue'))


	// DEMAND V2 (ВОРОНКА ПОТРЕБНОСТЕЙ)
	static readonly DemandV2Card          = new Dialog('DemandV2Card',          () => import('@/domains/DemandsV2/components/DemandV2Card/DemandV2Card.vue'), 'demandv2');
	static readonly DemandV2OptionDialog  = new Dialog('DemandOptionDialog',    () => import('@/domains/DemandsV2/components/DemandV2Card/DemandV2OptionDialog/DemandV2OptionDialog.vue'));
	static readonly DemandV2RequestDialog = new Dialog('DemandV2RequestDialog', () => import('@/domains/DemandsV2/components/DemandV2Card/DemandV2RequestDialog/DemandV2RequestDialog.vue'));
	static readonly MoveDemandV2          = new Dialog('MoveDemandV2',          () => import('@/domains/DemandsV2/components/DemandV2Registry/MoveDemandV2.vue'));

	// DEMAND (ПОТРЕБНОСТИ)
	static readonly DemandOrderCreateDialog      = new Dialog('DemandOrderCreateDialog',     () => import('@/domains/Demand/components/DemandOrderCreateDialog/DemandOrderCreateDialog.vue'));
	static readonly DemandImportDialog           = new Dialog('DemandImportDialog',          () => import('@/domains/Demand/components/DemandImportDialog/DemandImportDialog.vue'));
	static readonly MassChangeDialog             = new Dialog('MassChangeDialog',            () => import('@/domains/Demand/components/MassChangeDialog/MassChangeDialog.vue'));
	static readonly DemandBuyerRequisitesDialog  = new Dialog('DemandBuyerRequisitesDialog', () => import('@/domains/Demand/components/DemandBuyerRequisitesDialog/DemandBuyerRequisitesDialog.vue'));
	static readonly OrderOptionsComparisonDialog = new Dialog('OrderOptionsComparisonDialog',() => import('@/domains/Demand/components/OrderOptionsComparisonDialog/OrderOptionsComparisonDialog.vue'));

	// static readonly DemandOffersDialog          = new Dialog('DemandOffersDialog',          () => import('@/domains/Demand/components/DemandOffersDialog/DemandOffersDialog.vue'));
	static readonly DemandCard                  = new Dialog('DemandCard',                  () => import('@/domains/Demand/components/DemandCard/DemandCard.vue'), 'demand');

	// CONTRACT EXTERNAL (ВНЕШНИЕ ДОГОВОРЫ)
	static readonly ContractExternalCard = new Dialog('ContractExternalCard', () => import('@/domains/Contracts/components/ContractExternalCard/ContractExternalCard.vue'), 'contract');

	// TRANSPORT ORDER (ТРАНСПОРТНЫЕ ЗАКАЗЫ)
	static readonly TransportOrderRequisitesDialog = new Dialog('TransportOrderRequisitesDialog', () => import('@/domains/TransportOrders/components/TransportOrderCard/TransportOrderRequisitesDialog.vue'));
	static readonly TransportOrderCard = new Dialog('TransportOrderCard', () => import('@/domains/TransportOrders/components/TransportOrderCard/TransportOrderCard.vue'));
	static readonly TransportOrderStatusPopup = new Dialog('TransportOrderStatusPopup', () => import('@/domains/TransportOrders/components/TransportOrderStatusPopup/TransportOrderStatusPopup.vue'));
	static readonly TransportableDocumentsPicker = new Dialog('TransportableDocumentsPicker', () => import('@/domains/TransportOrders/components/TransportableDocumentsPicker.vue'));
	static readonly ProductsPicker = new Dialog('ProductsPicker', () => import('@/domains/TransportOrders/components/ProductsPicker.vue'));
	static readonly TransportDowntimeDialog = new Dialog('TransportDowntimeDialog', () => import('@/domains/TransportDowntime/components/TransportDowntimeDialog.vue'));
	static readonly TransportZoneCard = new Dialog('TransportZoneCard', () => import('@/domains/TransportZones/components/TransportZoneCard/TransportZoneCard.vue'));
	static readonly TransportRouteCard = new Dialog('TransportRouteCard', () => import('@/domains/TransportRoutes/components/TransportRouteCard/TransportRouteCard.vue'));
  static readonly DelivererCreatePopup = new Dialog('DelivererCreatePopup', () => import('@/domains/Partners/components/DelivererCreatePopup/DelivererCreatePopup.vue'));

	// SW PORTAL/MAILING (ПОРТАЛ И РАССЫЛКИ)
	static readonly SWPortalTaskCreateDialog = new Dialog('SWPortalTaskCreateDialog', () => import('@/domains/SWPortalTask/components/SWPortalTaskCreateDialog/SWPortalTaskCreateDialog.vue'));
	static readonly SWMailingListCreateDialog = new Dialog('SWMailingListCreateDialog', () => import('@/domains/TransportOrders/components/SWMailingListCreateDialog/SWMailingListCreate.vue'));

	// CARGO UNITS (ГРУЗОВЫЕ ЕДИНИЦЫ)
	static readonly CargoUnitsSummaryDialog = new Dialog('CargoUnitsSummaryDialog', () => import('@/domains/CargoUnits/components/CargoUnitsSummaryDialog/CargoUnitsSummaryDialog.vue'));
	static readonly CargoUnitCard = new Dialog('CargoUnitCard', () => import('@/domains/CargoUnits/components/CargoUnitCard/CargoUnitCard.vue'));

	// OFFER (ПРЕДЛОЖЕНИЯ)
	static readonly OfferCard = new Dialog('OfferCard', () => import('@/domains/Offers/components/OfferCard/OfferCard.vue'));
  static readonly OfferEditDialog = new Dialog('OfferEditDialog', () => import('@/domains/Offers/components/OfferEditDialog/OfferEditDialog.vue'));
  static readonly OffersRegistryDialog = new Dialog('OffersRegistryDialog', () => import('@/domains/Offers/components/OffersRegistryDialog/OffersRegistryDialog.vue'));

  // PRODUCT (ПРОДУКТЫ)
	static readonly ProductCard = new Dialog('ProductCard', () => import('@/domains/Products/components/ProductCard/ProductCard.vue'));

	// UNIT (ЕДИНИЦЫ ИЗМЕРЕНИЯ)
	static readonly UnitCard = new Dialog('UnitCard', () => import('@/domains/Units/components/UnitCard/UnitCard.vue'));

	// TENDER (ТЕНДЕРЫ)
	static readonly TenderCard         = new Dialog('TenderCard',         () => import('@/domains/Tenders/components/TenderCard/TenderCard.vue'), 'tender');
	static readonly TenderCreateCard         = new Dialog('TenderCreateCard',         () => import('@/domains/Tenders/components/TenderCard/TenderCreateCard.vue'));
	static readonly TenderChangeCurrencyPopup         = new Dialog('TenderChangeCurrencyPopup',         () => import('@/domains/Tenders/components/TenderCard/TenderChangeCurrencyPopup.vue'));
	static readonly TenderChangeBidPopup         = new Dialog('TenderChangeBidPopup',         () => import('@/domains/TenderBids/components/TenderBidChangePopup/TenderBidChangePopup.vue'));
	static readonly TenderRequisites         = new Dialog('TenderRequisites',         () => import('@/domains/Tenders/components/TenderRequisites/TenderRequisites.vue'));

	static readonly TenderBidCard    = new Dialog('TenderBidCard',    () => import('@/domains/TenderBids/components/CreateTenderBid/TenderBidCard.vue'));
  static readonly TenderBidMismatchDialog = new Dialog('TenderBidMismatchDialog', () => import('@/domains/TenderBids/components/CreateTenderBid/TenderBidMismatchDialog.vue'));
	static readonly PriceModPopup    = new Dialog('PriceModPopup',    () => import('@/domains/TenderBids/components/PriceDescription/PriceModPopup.vue'));

  static readonly TenderRefuseDialog = new Dialog('TenderRefuseDialog', () => import('@/domains/Tenders/components/TenderRefuseDialog/TenderRefuseDialog.vue'));
	static readonly DeferredPaymentPopup = new Dialog('DeferredPaymentPopup', () => import('@/domains/TenderBids/components/CreateTenderBid/DeferredPaymentPopup/DeferredPaymentPopup.vue'));

	// COMPANY (КОМПАНИИ)
	static readonly CompanyCard = new Dialog('CompanyCard', () => import('@/domains/Companies/components/CompanyCard/CompanyCard.vue'));

	// PARTNER (ПАРТНЕРЫ)
	static readonly PartnerCard = new Dialog('PartnerCard', () => import('@/domains/Partners/components/PartnerCard/PartnerCard.vue'), 'partner');
	static readonly PersonCard = new Dialog('PersonCard', () => import('@/domains/Persons/PersonCard/PersonCard.vue'));

	// SUPPLY OFFERS (РАЗРЕШЕНИЯ НА ПОСТАВКУ)
	static readonly SupplyOfferCard        = new Dialog('SupplyOfferCard',        () => import('@/domains/SupplyOffers/components/SupplyOfferCard/SupplyOfferCard.vue'));
	static readonly SupplyOfferTariffCard  = new Dialog('SupplyOfferTariffCard',  () => import('@/domains/SupplyOffers/components/SupplyOfferCard/SupplyOfferTariffCard.vue'));
	static readonly SupplyOfferStatusPopup = new Dialog('SupplyOfferStatusPopup', () => import('@/domains/SupplyOffers/components/SupplyOfferStatusPopup/SupplyOfferStatusPopup.vue'));

	// PRODUCT CATEGORY (КАТЕГОРИИ ПРОДУКТОВ)
	static readonly ProductCategoryAllowedUnitsDialog    = new Dialog('ProductCategoryAllowedUnitsDialog',    () => import('@/domains/ProductCategories/components/EditProductCategory/components/ProductCategoryAllowedUnitsDialog/ProductCategoryAllowedUnitsDialog.vue'));
	static readonly ProductCategoryCharacteristicsDialog = new Dialog('ProductCategoryCharacteristicsDialog', () => import('@/domains/ProductCategories/components/EditProductCategory/components/ProductCategoryCharacteristicsDialog/ProductCategoryCharacteristicsDialog.vue'));

	// Характеристики
	static readonly CharacteristicCard      = new Dialog('CharacteristicCard', () => import('@/domains/Characteristics/components/CharacteristicCard.vue'), 'characteristic');
	static readonly CharacteristicUnitCard  = new Dialog('CharacteristicUnitCard', () => import('@/domains/CharacteristicUnits/components/CharacteristicUnitCard/CharacteristicUnitCard.vue'), 'characteristicUnit');
	static readonly CharacteristicGroupCard = new Dialog('CharacteristicGroupCard', () => import('@/domains/CharacteristicGroups/components/CharacteristicGroupCard.vue'), 'characteristicGroup');

	// CATALOG/ADMIN (КАТАЛОГИ/АДМИН)
	static readonly ManufacturerCard = new Dialog('ManufacturerCard', () => import('@/domains/Manufacturers/components/ManufacturerCard/ManufacturerCard.vue'));
	static readonly PackageCard = new Dialog('PackageCard', () => import('@/domains/Packages/components/PackageCard/PackageCard.vue'));
	static readonly StoreCard = new Dialog('StoreCard', () => import('@/domains/Stores/components/StoreCard/StoreCard.vue'), 'store');

	// BANK ACCOUNTS (БАНКОВСКИЕ СЧЕТА)
	static readonly BankAccountCard = new Dialog('BankAccountCard', () => import('@/domains/BankAccounts/components/BankAccountCard/BankAccountCard.vue'));

	// REPORTS/PRODUCTION (ОТЧЕТЫ/ПРОИЗВОДСТВО)
	static readonly ProductionPlansImportDialog     = new Dialog('ProductionPlansImportDialog',     () => import('@/domains/ProductionPlans/components/ProductionPlansImportDialog/ProductionPlansImportDialog.vue'));
	static readonly ReportsDropOverlayDialog        = new Dialog('ReportsDropOverlayDialog',        () => import('@/domains/ProductionPlans/components/ProductionPlansImportDialog/ReportsDropOverlayDialog/ReportsDropOverlayDialog.vue'));
	static readonly ReportsLoadingDialog            = new Dialog('ReportsLoadingDialog',            () => import('@/domains/ProductionPlans/components/ProductionPlansImportDialog/ReportsLoadingDialog/ReportsLoadingDialog.vue'));
	static readonly ProductionPlansAddPositionPopup = new Dialog('ProductionPlansAddPositionPopup', () => import('@/domains/ProductionPlans/components/ProductionPlansRegistry/ProductionPlansAddPositionPopup/ProductionPlansAddPositionPopup.vue'));
  static readonly AddProductionPositionPopup      = new Dialog('AddProductionPositionPopup',      () => import("@/domains/ProductionPlans/components/ProductionPlansRegistry/ProductionPlansAddPositionPopup/ProductionPlansAddPositionPopup.vue"))

	// FILES (ФАЙЛЫ)
	static readonly FilesDialog = new Dialog('FilesDialog', () => import('@/core/services/Files/components/FilesDialog/FilesDialog.vue'));
	static readonly VFilesUploadConfirmationDialog = new Dialog('VFilesUploadConfirmationDialog', () => import('@/core/services/Files/components/VFilesUploadConfirmationDialog/VFileUploadConfirmationDialog.vue'));
	static readonly FilesSelectUploadDialog = new Dialog('FilesSelectUploadDialog', () => import('@/core/services/Files/components/FilesSelectUploadDialog/FilesSelectUploadDialog.vue'));

	// VEHICLES (ТРАНСПОРТ)
	static readonly VehicleTypeCard = new Dialog('VehicleTypeCard', () => import('@/domains/VehicleTypes/components/VehicleTypeCard.vue'));
	static readonly VehicleCard = new Dialog('VehicleCard', () => import('@/domains/Vehicles/components/VehicleCard.vue'));

	// TRADEMARK (ТОРГОВЫЕ МАРКИ)
	static readonly TradeMarkCard = new Dialog('TradeMarkCard', () => import('@/domains/TradeMarks/components/TradeMarkCard/TradeMarkCard.vue'), 'trademark');

  //BUDGET PRICES (БЮДЖЕТНЫЕ ЦЕНЫ)
  static readonly BudgetPriceCard = new Dialog('BudgetPriceCard', () => import('@/domains/BudgetPrices/components/BudgetPriceCard/BudgetPriceCard.vue'), 'budgetPrice');

  static readonly ProductCodeMappingCard = new Dialog('ProductCodeMappingCard', () => import('@/domains/ProductCodeMappings/components/ProductCodeMappingCard/ProductCodeMappingCard.vue'), 'productCodeMapping');

	// === ФЛАГ ИНИЦИАЛИЗАЦИИ ===
	private static isInitialized: boolean = false;

	/**
	 * Карта "имя сущности → диалог" для открытия по прямой ссылке (DialogsRouter).
	 * Строится один раз в init() из всех диалогов, у которых задан routeEntityName.
	 */
	private static entityDialogsMap: Map<string, Dialog> | null = null;


	/**
	 * Инициализация реестра и сервиса диалогов
	 */
	static init(): typeof DialogsRegistry {
		if (this.isInitialized) {
			return this;
		}

		DialogsService.init();

		// Сразу строим карту "сущность → диалог": ошибки конфигурации реестра
		// (дубликаты routeEntityName) всплывают при старте приложения,
		// а не при первом переходе по ссылке на карточку
		this.buildEntityDialogsMap();

		this.isInitialized = true;
		return this;
	}

	static get activeDialogs() { return DialogsService.activeDialogs; }

	// === ДЕЛЕГИРОВАННЫЕ МЕТОДЫ УПРАВЛЕНИЯ ===

	static get show() { return DialogsService.show.bind(DialogsService); }
	static get hide() { return DialogsService.hide.bind(DialogsService); }
	static get hideIfOpen() { return DialogsService.hideIfOpen.bind(DialogsService); }
	static get hideAll() { return DialogsService.hideAll.bind(DialogsService); }
	static get getTopDialog() { return DialogsService.getTopDialog.bind(DialogsService); }

	// === УТИЛИТЫ ===

	static get confirm() { return DialogsUtils.confirm.bind(DialogsUtils); }
	static get confirmWithReason() { return DialogsUtils.confirmWithReason.bind(DialogsUtils); }

	// === СЛУЖЕБНЫЕ МЕТОДЫ РЕЕСТРА ===

	/**
	 * Получить все диалоги
	 */
	static getAllDialogs(): Dialog[] {
		const dialogs: Dialog[] = [];

		for (const key of Object.keys(this)) {
			const value = (this as any)[key];
			if (value instanceof Dialog) {
				dialogs.push(value);
			}
		}

		return dialogs;
	}

	/**
	 * Найти диалог по имени компонента (имени статического поля реестра).
	 * Не-Dialog статики класса (init, isInitialized и т.д.) отсекаются.
	 */
	static getDialogByComponentName(componentName: string): Dialog | null {
		const value = (this as any)[componentName];

		if (value instanceof Dialog) {
			return value;
		} else {
			return null;
		}
	}

	/**
	 * Найти диалог-карточку по имени сущности (например 'assembly').
	 * Используется DialogsRouter для восстановления диалогов из URL.
	 * Требует предварительного вызова init() — карта строится там.
	 */
	static getDialogByEntityName(entityName: string): Dialog | null {
		if (this.entityDialogsMap === null) {
			throw new Error('DialogsRegistry: getDialogByEntityName вызван до init()');
		}

		return this.entityDialogsMap.get(entityName) ?? null;
	}

	/**
	 * Построить карту "имя сущности → диалог".
	 * routeEntityName гарантированно в camelCase (нормализуется конструктором Dialog),
	 * поэтому ключи используются как есть, без нормализации регистра.
	 * При дубликате побеждает первый зарегистрированный диалог, остальные игнорируются.
	 */
	private static buildEntityDialogsMap(): void {
		const map = new Map<string, Dialog>();

		for (const dialog of this.getAllDialogs()) {
			if (dialog.routeEntityName !== null) {
				const key = dialog.routeEntityName;

				if (map.has(key)) {
					console.error(`DialogsRegistry: дубликат routeEntityName "${key}": диалог "${dialog.name}" игнорируется, сущность закреплена за "${map.get(key)!.name}". На одну сущность должна быть ровно одна карточка.`);
				} else {
					map.set(key, dialog);
				}
			} else {
				// диалог без роутинга — пропускаем
			}
		}

		this.entityDialogsMap = map;
	}
}

export default DialogsRegistry;
